import React from 'react';
import AmountInput from './AmountInput';

function fmt(n) {
  return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 2 }).format(n || 0);
}

const toggleBtn = (active) => ({
  flex: 1, padding: '8px 6px', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 700,
  background: active ? 'var(--green-mid)' : '#f4f4f4',
  color: active ? '#fff' : '#555',
  border: active ? '1px solid var(--green-mid)' : '1px solid #eee',
});

/**
 * Flexible price entry: the farmer either types the unit price (total auto-calculated)
 * or the total amount (unit price auto-calculated). The parent owns state + recalculation;
 * this component is presentational.
 *
 * Props: mode ('unit'|'total'), unit, quantity, unitPrice, totalAmount,
 *        onMode(m), onUnitPrice(v), onTotal(v)
 */
export default function PriceModeFields({ mode = 'unit', unit = 'kg', quantity, unitPrice, totalAmount, onMode, onUnitPrice, onTotal }) {
  const q = parseFloat(quantity);
  const up = parseFloat(unitPrice);
  const total = parseFloat(totalAmount);

  return (
    <div style={{ marginBottom: 8 }}>
      {/* Mode toggle */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
        <button type="button" style={toggleBtn(mode === 'unit')} onClick={() => onMode('unit')}>💱 Birim Fiyat</button>
        <button type="button" style={toggleBtn(mode === 'total')} onClick={() => onMode('total')}>💰 Toplam Tutar</button>
      </div>

      {mode === 'unit' ? (
        <>
          <div className="form-group">
            <label>Birim Fiyat (₺) *</label>
            <input type="number" step="0.01" inputMode="decimal" value={unitPrice || ''}
              onChange={e => onUnitPrice(e.target.value)} placeholder="0.00" required />
          </div>
          <div style={{ background: '#f0f7ee', borderRadius: 8, padding: '8px 12px', fontWeight: 800, color: '#2d5a27' }}>
            Toplam: {(q > 0 && !isNaN(up)) ? fmt(q * up) : '—'}
          </div>
        </>
      ) : (
        <>
          <div className="form-group">
            <label>Toplam Tutar (₺) *</label>
            <AmountInput value={totalAmount} onChange={onTotal} required />
          </div>
          <div style={{ fontSize: '0.8rem', color: '#7a9472', padding: '2px 2px 0' }}>
            Birim Fiyat: {(q > 0 && !isNaN(total)) ? `${fmt(total / q)} / ${unit}` : '—'}
          </div>
        </>
      )}
    </div>
  );
}
